import { z } from "zod";
import { playbookIdSchema } from "../entities/playbook.js";
const selectedPlaybookSchema = z.object({
  id: playbookIdSchema,
  name: z.string()
});
export {
  selectedPlaybookSchema
};
//# sourceMappingURL=selectedPlaybook.js.map
